/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, Fragment } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import "../css/Ideas.css";
import { db } from "../firebase";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faPenToSquare, faTrashAlt, faX } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import { mostrarError, mostrarExito, mostrarInfo } from '../utils/Alertas';
import { hideLoading, showLoading } from '../../redux/actions/loadingActions';
import { useDispatch } from 'react-redux';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

interface Idea {
    id: string;
    idea: string;
}

const Ideas: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [idea, setIdea] = useState('');
    const [category, setCategory] = useState('Comida');
    const [comidaIdeas, setComidaIdeas] = useState<Idea[]>([]);
    const [actividadesIdeas, setActividadesIdeas] = useState<Idea[]>([]);
    const [isEditingCom, setIsEditingCom] = useState(false);
    const [isEditingAct, setIsEditingAct] = useState(false);
    const [comidaCompletadas, setComidaCompletadas] = useState<Idea[]>([]);
    const [actividadesCompletadas, setActividadesCompletadas] = useState<Idea[]>([]);

    const guardarIdea = async () => {
        if (!idea) {
            mostrarInfo('Por favor, ingresa una idea.');
            return;
        }

        try {
            await addDoc(collection(db, category), { idea });
            setIdea('');

            if (comidaIdeas.length === 0) {
                setIsEditingCom(false);
            } else if (actividadesIdeas.length === 0) {
                setIsEditingAct(false);
            }

            mostrarIdeas();
            mostrarExito('Idea guardada correctamente.');
        } catch (error) {
            console.error('Error guardando la idea: ', error);
            mostrarError('Error guardando la idea.');
        }
    };

    const eliminarIdea = async (category: string, id: string) => {
        try {
            await deleteDoc(doc(db, category, id));
            mostrarIdeas();
            var tipoIdea = category === 'Actividades' ? 'Actividad' : category;
            mostrarExito(tipoIdea + ' eliminada correctamente.');
        } catch (error) {
            console.error('Error eliminando la idea: ', error);
            mostrarError('Error eliminando la idea.');
        }
    };

    const completarIdea = async (category: string, id: string, idea: string) => {
        const completadaCategory = category === 'Comida' ? 'ComidasCompletadas' : 'ActividadesCompletadas';
        try {
            await addDoc(collection(db, completadaCategory), { idea });
            await deleteDoc(doc(db, category, id));
            mostrarIdeas();
            mostrarExito('La idea "' + idea + '" se ha completado con éxito.');
        } catch (error) {
            console.error('Error completando la idea: ', error);
            mostrarError('Error completando la idea.');
        }
    };

    const mostrarIdeas = async () => {
        dispatch(showLoading());
        try {
            const comidaSnapshot = await getDocs(collection(db, 'Comida'));
            const comidaList: Idea[] = [];
            comidaSnapshot.forEach(doc => {
                comidaList.push({ id: doc.id, idea: doc.data().idea });
            });
            setComidaIdeas(comidaList);

            const actividadesSnapshot = await getDocs(collection(db, 'Actividades'));
            const actividadesList: Idea[] = [];
            actividadesSnapshot.forEach(doc => {
                actividadesList.push({ id: doc.id, idea: doc.data().idea });
            });
            setActividadesIdeas(actividadesList);

            const comidaCompletadasSnapshot = await getDocs(collection(db, 'ComidasCompletadas'));
            const comidaCompletadasList: Idea[] = [];
            comidaCompletadasSnapshot.forEach(doc => {
                comidaCompletadasList.push({ id: doc.id, idea: doc.data().idea });
            });
            setComidaCompletadas(comidaCompletadasList);

            const actividadesCompletadasSnapshot = await getDocs(collection(db, 'ActividadesCompletadas'));
            const actividadesCompletadasList: Idea[] = [];
            actividadesCompletadasSnapshot.forEach(doc => {
                actividadesCompletadasList.push({ id: doc.id, idea: doc.data().idea });
            });
            setActividadesCompletadas(actividadesCompletadasList);
        } catch (error) {
            console.error('Error obteniendo las ideas: ', error);
            mostrarError('Error obteniendo la idea.');
        } finally {
            dispatch(hideLoading());
        }
    };

    const toggleEdit = (category: string) => {
        if (category === "edit-com") {
            setIsEditingCom(prev => !prev);
        } else if (category === "edit-act") {
            setIsEditingAct(prev => !prev);
        }
    };

    useEffect(() => {
        mostrarIdeas();
    }, []);

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="text-center">
                    <h2 className="pb-3">Lluvia de Ideas</h2>
                </div>

                <div className="container-fluid content pb-3">
                    <form onSubmit={(e) => { e.preventDefault(); guardarIdea(); }}>
                        <div className="input-group">
                            <TextField
                                label="Ingresa tu idea"
                                id="idea"
                                value={idea}
                                onChange={(e) => setIdea(e.target.value)}
                                fullWidth
                                margin="normal"
                                style={{ marginTop: 0 }}
                            />
                        </div>
                        <FormControl fullWidth margin="normal" style={{ marginTop: 0 }}>
                            <InputLabel id="category-label">Selecciona la categoría</InputLabel>
                            <Select
                                labelId="category-label"
                                id="category"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                label="Selecciona la categoría"
                            >
                                <MenuItem value="Comida">Comida</MenuItem>
                                <MenuItem value="Actividades">Actividades</MenuItem>
                            </Select>
                        </FormControl>
                        <button className="main-button" type="submit">Guardar Idea</button>
                    </form>
                    {comidaIdeas.length > 0 && <div className="list" id="comidaList">
                        <div className="list-header">
                            <h3>Comida</h3>
                            {isEditingCom ? <FontAwesomeIcon className="edit-button" onClick={() => setIsEditingCom(prev => !prev)} icon={faX} />
                            : <FontAwesomeIcon className="edit-button" onClick={() => toggleEdit('edit-com')} icon={faPenToSquare} />}
                        </div>
                        <ul id="comidaItems">
                            {comidaIdeas.map((item) => (
                                <li key={item.id} className="idea-item">
                                    <span>{item.idea}</span>
                                    {isEditingCom && <div className="buttons">
                                        <button className="complete-button"><FontAwesomeIcon onClick={() => completarIdea('Comida', item.id, item.idea)} icon={faCheck} /></button>
                                        <button className="delete-button"><FontAwesomeIcon onClick={() => eliminarIdea('Comida', item.id)} icon={faTrashAlt} /></button>
                                    </div>}
                                </li>
                            ))}
                        </ul>
                    </div>}
                    {actividadesIdeas.length > 0 && <div className="list" id="actividadesList" style={{marginBottom: '5px'}}>
                        <div className="list-header">
                            <h3>Actividades</h3>
                            {isEditingAct ? <FontAwesomeIcon className="edit-button" onClick={() => setIsEditingAct(prev => !prev)} icon={faX} />
                            : <FontAwesomeIcon className="edit-button" onClick={() => toggleEdit('edit-act')} icon={faPenToSquare} />}
                        </div>
                        <ul id="actividadesItems">
                            {actividadesIdeas.map((item) => (
                                <li key={item.id} className="idea-item">
                                    <span>{item.idea}</span>
                                    {isEditingAct && <div className="buttons">
                                        <button className="complete-button"><FontAwesomeIcon onClick={() => completarIdea('Actividades', item.id, item.idea)} icon={faCheck} /></button>
                                        <button className="delete-button"><FontAwesomeIcon onClick={() => eliminarIdea('Actividades', item.id)} icon={faTrashAlt} /></button>
                                    </div>}
                                </li>
                            ))}
                        </ul>
                    </div>}
                </div>

                {(comidaCompletadas.length > 0 || actividadesCompletadas.length > 0) && <div className="text-center ideas-completadas">
                    <button className="btn-viajes-completados-1" onClick={() => navigate("/ideas-completadas")}>Ideas Completadas</button>
                </div>}
            </div>
        </Fragment>
    );
};

export default Ideas;
